// extracted by mini-css-extract-plugin
export default {"dempyou":"dempyou_dempyou__5CQlH","borderBottomDouble":"dempyou_borderBottomDouble__2wPZi"};